import React from 'react'
import { Spin } from 'antd'

const Segment = ({ loading, children }) => {
    return (
        <div style={{ position: 'relative', backgroundColor: 'white', padding: '20px' }}>
            {loading && (
                <div
                    style={{
                        position: 'absolute',
                        backgroundColor: 'rgba(255,255,255,0.7)',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 999,
                        margin: 'auto'
                    }}
                >
                    <Spin tip="Espere, por favor..." size="large" />
                </div>
            )}
            {children}
        </div>
    )
}

export default Segment
